import React, { useState } from 'react'

const FreeDelivery = ({ }) => {

    const formatTextChoice = (text) => {
        //return useTextFormatter(text);
        if (text === "") {
            return "";
        } else {
            const raw = text
                .replace(/\n/g, "<br />");
        
            return raw;
        }
        // const formatted = useMemo(() => {
        // if (!text) return "";
    
        
        // }, [text]);
    
        // return formatted;
    }

    return (
        <section className="checkout py-80">
            <div className="container container-md">
                <h6 className="text-xl mb-24">Free delivery fee across all Singapore</h6>
                <p>Free Shipping in Singapore is Free of all charges. However This Does Not Include : Changi Airport & Restricted Area, Sentosa Island area ( restricted Zone) , Tuas area ( restricted zone ) or require a surcharge or have specific restrictions.
                    And for Free Delivery exclude the area specified above, your Total Purchase must be above S$80, then will you Be Entitled To Free Delivery.
                </p>
                <span className='mb-24'>You Can Order Delivery Via This Link : <a href="www.pinkpeonyshopsg.com">www.pinkpeonyshopsg.com</a></span>
                    
                <p dangerouslySetInnerHTML={{__html: formatTextChoice(`ESTIMATED ARRIVAL FOR ALL ORDERS : BETWEEN 2 to 5 BUSINESS DAYS  FROM DATE OF PURCHASE\n
                    •⁠  ⁠IF YOU ARE NOT AGREEABLE TO THE TERMS OF PURCHASE PLEASE DO NOT PROCEED TO MAKE PAYMENT. ALL SALES ARE NON-REFUNDABLE AND NON-RETURNABLE*\n
                    Feel free to contact us with any question regarding our terms and conditions. Email to : idmartsg_cs@gmail.com`)}}>
                </p>

                    
            </div>
        </section>
    )
}

export default FreeDelivery